// extracted by mini-css-extract-plugin
export var filterIncDec = "_bv-0";
export var leftBorder = "_bv-1";
export var rightBorder = "_bv-2";
export var stringInput = "_bv-3";